import { grayLightBackground } from "@/_core/_helpers/_parametric_tools";
import { LineHover } from "./effects/LineHover";
import { TooltipHover } from "./effects/TooltipHover";
import { BarHover } from "./effects/BarHover";
import { DotHover } from "./effects/DotHover";
import { CandleHover } from "./effects/CandleHover";

export const ChartHover = {
  getGeneralParams(params = {}) {
    return { svg: this.svg, svgAux: this.svgAux, name: this.name, ...params };
  },
  createBarHover(params) {
    let generalParams = this.getGeneralParams(params);
    let barHover = new BarHover({ ...generalParams });
    this.findIndexElement({ nameElement: "hoverElements", instance: barHover });
  },
  createBarZoom(params) {
    let generalParams = this.getGeneralParams(params);
    let barHover = new BarHover({ ...generalParams });
    this.findIndexElement({ nameElement: "zoomElements", instance: barHover });
  },
  createCandleZoom(params) {
    let generalParams = this.getGeneralParams(params);
    let candleHover = new CandleHover({ ...generalParams });
    this.findIndexElement({
      nameElement: "zoomElements",
      instance: candleHover
    });
  },
  createToolTipsHover(types, params) {
    const generalParams = this.getGeneralParams(params);
    types.forEach(type => {
      const params = {
        type,
        ...generalParams
      };

      const tooltip = new TooltipHover(params);
      this.findIndexElement({
        nameElement: type === "last-y" ? "zoomElements" : "hoverElements",
        instance: tooltip
      });
    });
  },
  addHovers({ colorTheme, hLine = false, vLine = false, line = false }) {
    if (hLine) {
      let obj = new LineHover({
        ...this.getGeneralParams(),
        type: "h",
        strokeColor: grayLightBackground(colorTheme)
      });
      this.findIndexElement({ nameElement: "hoverElements", instance: obj });
    }
    if (vLine) {
      let obj = new LineHover({
        ...this.getGeneralParams(),
        type: "v",
        strokeColor: grayLightBackground(colorTheme)
      });
      this.findIndexElement({ nameElement: "hoverElements", instance: obj });
    }
    if (line) {
      let obj = new LineHover({
        ...this.getGeneralParams(),
        type: "line"
      });
      this.findIndexElement({ nameElement: "hoverElements", instance: obj });
    }
  },
  addDotHovers(params) {
    const generalParams = this.getGeneralParams(params);
    const obj = new DotHover({
      ...generalParams
    });
    this.findIndexElement({ nameElement: "hoverElementDots", instance: obj });
  },
  addHereditadryHovers(params) {
    params.hereditaryInstances.forEach(d => this["hereditaryHovers"].push(d));
  },
  findIndexElement({ nameElement, instance }) {
    const indexElement = this[nameElement].findIndex(
      d => d.className === instance.className
    );
    if (indexElement === -1) this[nameElement].push(instance);
    else this[nameElement].splice(indexElement, 1, instance);
  }
};
